import {
  Colors,
  Flex,
  HeaderContainer,
  HeaderIcon,
  NaviIconSearch,
  RemoteImage,
  Typography,
} from '@banhala/ui-kit';
import { CartIcon } from 'shared/src/component';
import { useHomeIcons } from './queries/useHomeIcons';
import { bridge, isNil, isNotNil } from 'shared/src/utils';
import React, { useCallback } from 'react';
import Svg, { Circle, Path } from 'react-native-svg';
import { useConfigs } from '../../../../../../../shared/src/queries';

const PointHeaderIcon: React.FC<{ onPress: () => void }> = props => {
  return (
    <HeaderIcon onPress={props.onPress}>
      <Svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <Circle cx="12" cy="12" r="12" fill="#FFD350" />
        <Path
          d="M13.2222 6.44493C15.3132 6.44498 17.0081 8.14005 17.0083 10.2311C17.0083 12.3222 15.3133 14.0181 13.2222 14.0182H11.3062V17.5641H8.81201V6.44493H13.2222ZM11.2798 8.62755V11.8346H12.8384C13.7241 11.8346 14.4429 11.1167 14.4429 10.2311C14.4428 9.34545 13.724 8.62755 12.8384 8.62755H11.2798Z"
          fill="white"
        />
      </Svg>
    </HeaderIcon>
  );
};

const ABLYLogo = () => {
  return (
    <Svg width="80" height="16" viewBox="0 0 80 16" fill="none">
      <Path
        d="M32.9811 0.0351562C35.0943 0.116157 37.0748 1.88043 37.0748 4.03125C37.0777 4.06614 37.2939 6.79561 35.025 7.5332C34.9692 7.55245 34.8733 7.57359 34.8209 7.59082C34.8323 7.59312 34.8437 7.59702 34.8551 7.59961C36.5889 7.98567 37.897 9.55149 37.8971 11.4121V12.0381C37.8971 14.1863 36.1567 15.9375 34.027 15.9375L29.0211 15.9355H24.8385L24.8356 0.0244141L29.0182 0.0253906L29.0455 0.0244141L32.9811 0.0351562ZM17.5153 15.9346H13.8405L12.401 12.4922H5.91565L4.4762 15.9346H0.801392L7.48694 0H10.8297L17.5153 15.9346ZM50.7213 12.7656H58.9879V15.9346H47.067V0H50.7213V12.7656ZM71.7028 5.92676L75.2399 0H79.1989L73.5299 9.64258V15.9346H69.8756V9.64258L64.2067 0H68.1656L71.7028 5.92676ZM28.5358 9.7168V13.2158H31.4078V13.2148H32.3268C33.2647 13.2147 34.1832 12.4409 34.1832 11.4951V11.4375C34.1832 10.4914 33.2647 9.71789 32.3268 9.71777H31.4078V9.7168H28.5358ZM7.22131 9.36914H11.0953L9.16956 4.74219L7.22131 9.36914ZM28.5358 2.74512V6.24414H31.7535C32.6912 6.24414 33.4584 5.47042 33.4586 4.52441V4.4668C33.4586 3.52064 32.6913 2.74609 31.7535 2.74609H31.4205V2.74512H28.5358Z"
        fill="#1F1F1F"
      />
    </Svg>
  );
};

const HomeHeaderContent = () => {
  const { data: homeIcons } = useHomeIcons();
  const { data: config } = useConfigs();

  const onPressLogo = useCallback(() => {
    if (isNil(homeIcons.logo)) return;
    if (isNotNil(homeIcons.logo.deeplink)) {
      bridge.openDeeplink(homeIcons.logo.deeplink);
    }
  }, [homeIcons.logo]);

  const onPressPoint = useCallback(() => {
    // bridge.openDeeplink('ably://point');
    bridge.toast('여기를 눌렀을때 onPressPoint');
  }, []);

  const onPressCart = useCallback(() => {
    // bridge.openDeeplink('ably://point');
    // bridge.toast('여기를 눌렀을때 onPressPoint')
    bridge.logAnalyticsEvent({
      channel: ['firebase', 'facebook', 'amplitude', 'ablylog'],
      name: 'CLICK_CART',
      analytics: {
        SCREEN: 'HOME',
        LANDING_FROM: 'CARTICON',
      },
    });
  }, []);

  const onPressSearch = useCallback(() => {}, []);

  return (
    <Flex>
      <HeaderContainer justifyContent={'space-between'}>
        <Flex justifyContent={'center'} padding={{ left: 12 }}>
          {isNotNil(homeIcons.logo) && isNotNil(homeIcons.logo.image_url) ? (
            <Flex onPress={onPressLogo}>
              <RemoteImage
                uri={homeIcons.logo.image_url}
                width={homeIcons.logo.image_width}
                height={homeIcons.logo.image_height}
              />
            </Flex>
          ) : (
            <Flex padding={{ left: 4 }}>
              <ABLYLogo />
            </Flex>
          )}
        </Flex>
        <Flex.Row padding={{ right: 8 }}>
          <PointHeaderIcon onPress={onPressPoint} />
          <CartIcon onPressCart={onPressCart} />
        </Flex.Row>
      </HeaderContainer>
      <Flex padding={{ horizontal: 12, bottom: 4 }}>
        <Flex.Row
          height={40}
          borderRadius={'small'}
          backgroundColor={'bg_secondary'}
          padding={{ horizontal: 12 }}
          alignItems={'center'}
          justifyContent={'space-between'}
          onPress={onPressSearch}
        >
          <Typography color={'content_secondary'} type={'body2'}>
            {config?.search_placeholder?.text ?? ''}
          </Typography>
          <NaviIconSearch size={20} fill={Colors.content_secondary} />
        </Flex.Row>
      </Flex>
    </Flex>
  );
};

export const HomeHeader = () => {
  return (
    <React.Suspense
      fallback={
        <HeaderContainer justifyContent={'space-between'}>
          <Flex justifyContent={'center'} padding={{ left: 12 }}>
            <Flex padding={{ left: 4 }}>
              <ABLYLogo />
            </Flex>
          </Flex>
          <Flex.Row padding={{ right: 8 }}>
            <PointHeaderIcon onPress={() => {}} />
            <CartIcon onPressCart={() => {}} />
          </Flex.Row>
        </HeaderContainer>
      }
    >
      <HomeHeaderContent />
    </React.Suspense>
  );
};
